import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'
import CustomDataGrid from '../../../components/DataGrid/CustomDataGrid'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import API from '../../../services/API'
import Button from '@mui/material/Button'
import AddNewSOP from './AddNewSOP'
import BigModal from '../../../components/Modals/BigModal'
import { Alert, Box } from '@mui/material'
import { Cancel, CheckCircle } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../../../App'

const Sops = () => {
  const [sops, setSops] = useState([])
  const [loading, setLoading] = useState(true)
  const [openAddNew, setOpenAddNew] = useState(false)
  const navigate = useNavigate()
  const { user } = useContext(UserContext)

  const allowedTeams = ['Governance']
  const isGovernanceUser = user.employee?.teams.some((team) =>
    allowedTeams.includes(team)
  )

  const loadSOPs = () => {
    setLoading(true)
    API.get('/sops')
      .then((res) => {
        if (res.status === 200) {
          setSops(res.data)
        }
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    loadSOPs()
  }, [])

  return (
    <Stack gap={1}>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        justifyContent="space-between"
      >
        <Typography variant="title2">
          Standard Operating Procedures & Guidelines
        </Typography>
        {isGovernanceUser && (
          <Button
            size="small"
            variant="outlined"
            color="anGreen"
            onClick={() => setOpenAddNew(true)}
          >
            Add
          </Button>
        )}
      </Stack>
      <CustomDataGrid
        norowsoverlay={
          <Alert
            severity="info"
            action={
              isGovernanceUser && (
                <Button
                  size="small"
                  color="inherit"
                  onClick={() => setOpenAddNew(true)}
                >
                  Add an SOP
                </Button>
              )
            }
          >
            {isGovernanceUser
              ? 'No SOPs or guidelines uploaded yet. Use Add to upload your first document — staff are then prompted to read and acknowledge it.'
              : "Your organisation hasn't uploaded any SOPs or guidelines yet. Documents shared with you will appear here to read and acknowledge."}
          </Alert>
        }
        rows={sops}
        getRowId={(params) => params?._id}
        columns={[
          {
            field: 'isAcknowledgedByCurrentUser',
            headerName: '',
            renderCell: ({ row }) => (
              <Box display="flex" justifyContent="center" alignItems="center">
                {row?.isAcknowledgedByCurrentUser ? (
                  <CheckCircle color="success" />
                ) : row?.requiresMyAcknowledgement || row?.faoAllStaff ? (
                  <Cancel color="error" />
                ) : (
                  ''
                )}
              </Box>
            ),
          },
          { field: 'title', headerName: 'Title', flex: 1 },
          { field: 'type', headerName: 'Type', flex: 0.6 },
          { field: 'sopNumber', headerName: 'Number', flex: 0.4 },
          {
            field: 'date',
            headerName: 'Date',
            renderCell: ({ value }) => moment(value).format('Do MMM YYYY'),
            flex: 0.4,
          },
        ]}
        loading={loading}
        disableRowSelectionOnClick
        onRowClick={({ row }) => navigate(row._id)}
        slots={{
          footer: () => null,
          toolbar: () => null,
        }}
      />
      <BigModal open={openAddNew} onClose={() => setOpenAddNew(false)}>
        <AddNewSOP onClose={() => setOpenAddNew(false)} loadSOPs={loadSOPs} />
      </BigModal>
    </Stack>
  )
}

export default Sops
